module.exports = __webpack_public_path__ + "static/img/active_vip_01.a2969e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_vip_01.jpg
// module id = HGRc
// module chunks = 0